import { noDataString } from '@/const/const';

/**
 * 格式化金额对象，将金额和货币格式化为统一格式
 * @param amount Amount对象
 * @returns 格式化后的金额字符串，格式为 "0.00EUR"
 */
export function formatAmountWithCurrency(amount) {
  if (!amount?.amount || !amount?.currency) {
    return noDataString;
  }

  return `${amount.amount}${amount.currency}`;
}
